import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { resetAllFileScanStatuses } from '../../actions/data/fileScan';
import useMutateApi from '../../api/hooks/useMutateApi';
import { CREATE_COMMENT } from '../../constants/endpoints';
import { COMMENTS_CREATE } from '../../constants/actions';
import { newError } from '../../actions/errors';
import queryKeys from './queryKeys';

const getCommentAction = (status, payload) => ({
  type: COMMENTS_CREATE,
  status,
  payload,
});

const useCreateComment = (entityType, entityId, onSuccess) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys.comments(entityType, entityId);
  const dispatch = useDispatch();

  return useMutateApi(
    {
      url: CREATE_COMMENT(),
      method: 'POST',
    },
    {
      onMutate: async () => {
        await queryClient.cancelQueries(queryKey);
        dispatch(getCommentAction('started', {}));
      },
      onSuccess: ({ comment }) => {
        // Manually update the cache with the correct queryKey (entityType/entityId from hook params)
        queryClient.setQueryData(queryKey, (data) => ({
          comments: [...(data?.comments || []), comment],
          reactions: data?.reactions || [],
        }));

        if (onSuccess) {
          onSuccess();
          dispatch(resetAllFileScanStatuses());
        }
        dispatch(
          getCommentAction('success', {
            comment,
          })
        );
      },
      onError: (error) => {
        dispatch(newError(error, 'createPostError'));
        dispatch({
          ...getCommentAction('error', {}),
          error,
        });
      },
    }
  );
};

export default useCreateComment;
